var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoJsonWizard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    fill: "none",
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F1C0E8",
    d: "M0 10C0 4.477 4.477 0 10 0h40c5.523 0 10 4.477 10 10v40c0 5.523-4.477 10-10 10H10C4.477 60 0 55.523 0 50V10Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#091540",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.333,
    d: "M36.553 16.008c4.58 0 7.447 3.23 7.447 7.81V36.18c0 4.58-2.867 7.812-7.447 7.812H23.432c-4.58 0-7.432-3.232-7.432-7.812V23.818c0-4.58 2.867-7.81 7.432-7.81h6.876m-7.241 27.97 9.54-10.843a3.176 3.176 0 0 0-.287-4.492l-1.729-1.515a3.18 3.18 0 0 0-4.506.272l-2.123 2.411-7.69 8.707m10.934-5.848 3.246 2.86m6.835-8.508v-.06m-2.083 10.606v.06m-13.25-14.86v-.06m14.621-.241v-.061"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoJsonWizard);
export default __webpack_public_path__ + "static/media/logo-json-wizard.4844deded4052ee991e9dd0ce0521e11.svg";
export { ForwardRef as ReactComponent };